<template>
  <div>
    <PageHead title="草稿箱"></PageHead>
    <div class="drafts oa-layout-content">
      <a-table :pagination="false" :columns="columns" :data-source="data">
        <div slot="action">
          <a-button type="link" class="btn-link" @click="add()">
            修改
          </a-button>
          <a-divider type="vertical" />
          <a-button type="link" class="btn-link"> 删除 </a-button>
        </div>
      </a-table>
      <div class="pagination">
        <a-pagination :default-current="1" :total="500" @change="pageChange" />
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>

<script>
const columns = [
  {
    title: '序号',
    dataIndex: 'name',
    key: 'name',
    width: 80
  },
  {
    title: '隐患问题描述',
    dataIndex: 'address',
    key: 'address 1',
    ellipsis: true
  },
  {
    title: '上报机构',
    dataIndex: 'age',
    key: 'age'
  },
  {
    title: '上报人',
    dataIndex: 'tags',
    key: 'tags',
    ellipsis: true
  },
  {
    title: '隐患级别',
    dataIndex: 'number',
    key: 'number',
    scopedSlots: { customRender: 'number' }
  },
  {
    key: 'operation',
    scopedSlots: { customRender: 'action' },
    title: '操作',
    align: 'center'
  }
]

const data = [
  {
    key: '1',
    time: 2124343,
    name: 32,
    age: '财务部',
    number: 3434344,
    address: '养老产品项目砂浆产品供货合同',
    status: 1,
    tags: '23%'
  },
  {
    key: '2',
    name: 42,
    time: 42333,
    number: 8343434,
    age: '科技部',
    address: '美容产品新开发合同',
    status: 2,
    tags: '90%'
  },
  {
    key: '333',
    name: 4299,
    time: 42333,
    number: 8343434,
    age: '娱乐部',
    address: '养老产品项目砂浆产品供货合同',
    status: 3,
    tags: '50%'
  }
]
export default {
  data() {
    return {
      data,
      columns
    }
  },
  methods: {
    add() {},
    pageChange(pageNumber) {
      console.log('Page: ', pageNumber)
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/PotentialSafetyHazard/drafts.vue